export const STORAGE = {
  ACCESS_TOKEN: 'access_token',
  WALLET: 'wallet_address',
  USER_INFO: 'user_info'
}

export const EVENT_BUS = {
  APP_LOADING: 'app-loading',
}
